import { Grid, Typography } from "@mui/material"
import { t } from "i18next"

const About = () => {

    return (
        <Grid container direction="column" alignItems="center" justifyContent="center">
            <Typography sx={{ marginTop: 10 }} fontWeight="bold" fontSize={24}>
                {t('AboutMessage')}
            </Typography>
        </Grid>
    )
}

export default About